module.exports = __webpack_public_path__ + "assets/media/promocode-info.ebc8dd5d.svg";